import { render } from "./NavbarHome.vue?vue&type=template&id=5086aacf&scoped=true"
import script from "./NavbarHome.vue?vue&type=script&lang=js"
export * from "./NavbarHome.vue?vue&type=script&lang=js"

import "./NavbarHome.vue?vue&type=style&index=0&id=5086aacf&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5086aacf"]])

export default __exports__